import React, { Component } from 'react';
import Layout from './components/Layout/Layout';
import { Route, Routes } from 'react-router-dom';
import MainBuilder from './containers/mainbuilder/mainbuilder';
import './App.scss';
import './materialdesignicons.min.css';
import './custom.css';

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Layout>
          <Routes>
            <Route path="/*" element={<MainBuilder />} />
          </Routes>
        </Layout>
      </React.Fragment>
    );
  }
}

export default App;
